import { getProcessDataById } from "@/pages/caster/repositories/ProductionRepository";
import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { ErrorModal, getMomentTz } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useTableData } from "./hooks/useTableData";

type LostStrandRow = {
	LostStrandId: number;
	ProcessId: number;
	StrandId: number;
	LostStrandTypeId: number;
	LostStrandTypeName: string;
	Comment: string | null;
	Timestamp: Date;
	Author: string;
	IsManual: boolean;
};

const moment = getMomentTz();

export const LostStrandsReadOnly = () => {
	const {
		state: { casProcessData },
	} = useHeatReportContext();

	const [error, setError] = useState<string | null>(null);
	const [rows, setRows] = useState<LostStrandRow[]>([]);

	useEffect(() => {
		(async () => {
			try {
				const processId = (casProcessData as any)?.ProcessId as
					| number
					| undefined;
				if (!processId) {
					setRows([]);
					return;
				}
				const resp = await getProcessDataById(processId);
				if (resp.ok) {
					const lost = resp.data?.tables?.[3]?.rows || [];
					const mapped: LostStrandRow[] = lost.map((r: any) => ({
						...r,
						Timestamp: r.Timestamp ? moment.utc(r.Timestamp).toDate() : null,
					}));
					setRows(mapped);
				} else {
					setError(resp.message);
				}
			} catch (e: any) {
				setError(e.message || String(e));
			}
		})();
	}, [casProcessData]);

	const { columns } = useTableData();

	return (
		<Paper elevation={0} style={{ height: "100%" }}>
			<Box style={{ height: "11rem", border: "1px solid #e0e0e0" }}>
				<AgGridReact
					rowSelection="single"
					suppressRowClickSelection={true}
					pagination={false}
					singleClickEdit={false}
					tooltipShowDelay={0}
					tooltipHideDelay={2000}
					rowData={rows}
					columnDefs={columns}
					domLayout="normal"
					suppressContextMenu={true}
				/>
			</Box>
			<ErrorModal error={error} onHide={() => setError(null)} />
		</Paper>
	);
};
